import type { StatsigOptions } from "statsig-node-lite";

/** Default timeout for Statsig server SDK initialization (ms). */
export const STATSIG_INIT_TIMEOUT_MS = 10000;

/**
 * Resolves the Statsig environment tier from environment variables.
 *
 * Resolution order:
 * 1. STATSIG_TIER (server-only override)
 * 2. NEXT_PUBLIC_STATSIG_TIER (explicit tier)
 * 3. Vercel environment detection (staging / production)
 * 4. Defaults to "development"
 */
export function getStatsigTier(): string {
  if (process.env.STATSIG_TIER) return process.env.STATSIG_TIER;
  if (process.env.NEXT_PUBLIC_STATSIG_TIER)
    return process.env.NEXT_PUBLIC_STATSIG_TIER;
  if (
    process.env.VERCEL_TARGET_ENV === "staging" ||
    process.env.NEXT_PUBLIC_VERCEL_ENV === "staging"
  )
    return "staging";
  if (
    process.env.VERCEL_TARGET_ENV === "production" ||
    process.env.NEXT_PUBLIC_VERCEL_ENV === "production"
  )
    return "production";
  return "development";
}

/**
 * Shared server-side Statsig options with timeout protection.
 * Prevents function invocation timeouts when api.statsigcdn.com is unreachable.
 */
export function getStatsigServerOptions(): StatsigOptions {
  return {
    environment: { tier: getStatsigTier() },
    initTimeoutMs: STATSIG_INIT_TIMEOUT_MS,
  };
}
